import React from 'react';
import Modal from './Modal';

type onCloseFn = () => void;

type Props = {
  load: () => Promise<any>,
  render: (result: any) => React.Element,
  trigger: ?React.Element,
  isOpened: ?boolean,
  onClose: onCloseFn,
}


export default class LazyModal extends React.Component {
  constructor(props: Props) {
    super(props);
    this.state = { ready: false, result: null };
  }

  componentDidMount() {
    if (this.props.isOpened && !this.state.ready) {
      this.load();
    }
  }

  componentDidUpdate() {
    if (this.props.isOpened && !this.state.ready) {
      this.load();
    }
  }

  load = async () => {
    const result = await this.props.load();
    this.setState({ready: true, result});
  };

  render() {
    const { isOpened, render, ...props } = this.props;
    const { ready, result } = this.state;

    return (
      <Modal {...props} isOpened={ready && isOpened} render={() => render(result)} />
    );
  }
}



// WEBPACK FOOTER //
// ../src/client/components/modal/LazyModal.js